export default __webpack_public_path__ + "static/media/modalIcon.5bb43093.svg";